import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { DataTransformService, ProductCategory } from '@ridango/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductCategoriesActions } from './+state/product-categories.actions';
import { ProductCategoriesState } from './+state/product-categories.reducer';

@Injectable({
    providedIn: 'root'
})
export class ProductCategoriesService {

    constructor(@Inject('ENV') private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<ProductCategoriesState>,
        private actions: ProductCategoriesActions) {}
    fetchProductCategoriesRequest(): Observable<any> {
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/categories`);
    }
    setAllCategories(categories: ProductCategory[]) {
        this.ngRedux.dispatch(this.actions.setAllCategories(categories));
    }

    setFilteredTravellerCategories(categories: ProductCategory[]) {
        categories = categories.sort((a, b) => a.order > b.order ? 1 : a.order < b.order ? - 1 : 0);
        this.ngRedux.dispatch(this.actions.setFilteredTravellerCategories(categories));
    }
    setSelectedTravellerCategory(category: ProductCategory) {
        this.ngRedux.dispatch(this.actions.setSelectedTravellerCategory(category));
    }


    setFilteredProductCategories(categories: ProductCategory[]) {
        categories = categories.sort((a, b) => a.order > b.order ? 1 : a.order < b.order ? - 1 : 0);
        this.ngRedux.dispatch(this.actions.setFilteredProductCategories(categories));
    }
    setSelectedProductCategory(category: ProductCategory) {
        this.ngRedux.dispatch(this.actions.setSelectedProductCategory(category));
    }

}
